import React, { useState, useEffect, useRef } from "react";
import { S_SKU, webStorage } from "../../utils/webStorage";
import { saveInStoreOrder } from "../../services/orderService";
import url from "url";
import querystring from "querystring";
import { appendQuery } from "../../utils/urlHelper";
import config from "../../temp/config";
import HeroGradient from "../hero-gradient";
import AccordionWrapper from "../../elements/accordion-wrapper";
import Summary from "../summary";
import { startWatchOrder, stopWatchOrder } from "../../utils/orderWatcher";
import PreSalesCardInfoInStore from "../presales-card-info-in-store";
import storeApi from "../../utils/storeApi";
import api from "../../utils/api";
import PreSalesBillingInfo from "../presales-billing-info";
let submitting = false;
const PreSalesCheckoutViewInStore = props => {
  const { lang, hero, newAddressLabel, billingInfo, cardInfo, /*delivery,*/ summary, user, club, confirmationUrl, becomeAMemberSummary, onSummaryCallback, match, onError } = props;
  const billingInfoRef = useRef();
  const [addressList, setAddressList] = useState([]);
  const [noAddress, setNoAddress] = useState(false);
  useEffect(() => {
    loadAddressList();
  }, []);
  const loadAddressList = async () => {
    let _addressList = await getAddressList();
    setNoAddress(_addressList.length === 0);
    setAddressList(_addressList);
  };
  const getAddressList = async () => {
    let { obj } = await api.address.list();
    let _addressList = (obj || []).map(address => {
      return { address: address, value: address.addressId };
    });
    if (_addressList.length > 0) {
      _addressList.push({ label: newAddressLabel.value, value: "new" });
    }
    return _addressList;
  };
  const addAddress = async address => {
    const newAddressList = await getAddressList();
    const addedItem = newAddressList.find(x => addressList.every(y => x.value !== y.value));
    addedItem.address.firstName = address.firstName;
    addedItem.address.lastName = address.lastName;
    addedItem.isNew = true;
    setNoAddress(newAddressList.length === 0);
    setAddressList(newAddressList);
    return addedItem;
  };
  const updateAddress = async () => {
    const newAddressList = addressList.slice();
    const newAddr = newAddressList.find(x => x.isNew);
    if (newAddr) {
      delete newAddr.isNew;
    }
    setAddressList(newAddressList);
  };
  const removeAddress = address => {
    const index = addressList.findIndex(x => x === address);
    addressList.splice(index, 1);
    const newAddressList = addressList.slice();
    const newAddr = newAddressList.find(x => x.isNew);
    if (newAddr) {
      delete newAddr.isNew;
    }
    setAddressList(newAddressList);
  };
  const [qrCodeSrc, setQRCodeSrc] = useState(null);
  useEffect(() => {
    return () => {
      stopWatchOrder();
    };
  }, []);
  const submitOrder = async () => {
    if (!submitting) {
      try {
        const sku = webStorage.get(S_SKU);
        const { isValid: isBillingInfoValid, formData: billingFormData } = billingInfoRef.current.validateForm();
        if (isBillingInfoValid) {
          const skuQtyVoList = [
            {
              qty: 1,
              skuId: sku
            }
          ];
          const billingInfoData = {
            billingFirstName: billingFormData.firstName,
            billingLastName: billingFormData.lastName,
            billingEmail: user?.email,
            billingPhone: `${user.mobileNoCountryCode}${user.mobileNo}`,
            billingCountryCode: billingFormData.countryCode,
            billingAddress1: billingFormData.street,
            billingAddress2: billingFormData.apartment,
            billingPostalCode: billingFormData.postalCode,
            billingCity: billingFormData.city,
            billingCountry: billingFormData.country,
            billingCountryId: billingFormData.countryId
          };
          const {
            obj: { orderNo, orderId }
          } = await saveInStoreOrder(billingInfoData, skuQtyVoList, club);
          const orderLink = url.parse(confirmationUrl.value?.href);
          const query = querystring.parse(orderLink.query);
          const redirect = decodeURIComponent(query.redirect);
          const queryMembership = becomeAMemberSummary?.membership;
          const nextUrl = appendQuery(redirect, {
            orderNo: orderNo,
            orderId: orderId,
            inStore: true,
            membership: queryMembership
          });
          let returnUrl = decodeURIComponent(
            appendQuery(confirmationUrl.value.href, {
              ...query,
              redirect: encodeURIComponent(nextUrl)
            })
          );
          // let returnUrl = confirmationUrl.value?.href;
          if (!/^https?/i.test(returnUrl)) {
            returnUrl = config.sitecoreApiHost + returnUrl;
          }
          const {
            obj: { redirectUrl, status }
          } = await storeApi.order.pay(null, {
            orderNo: orderNo, //订单号
            isRemember: 0, //此项目勾选可以保存本次paymenttoken
            returnUrl: returnUrl
          });
          setQRCodeSrc(redirectUrl);
          await startWatchOrder({ redirect: nextUrl, orderId, orderNo, onError });
        }
      } catch (ex) {
        onError && onError(ex);
        console.error(ex);
      } finally {
        submitting = false;
      }
    }
  };
  /*const measurements = () => {
    if (becomeAMemberSummary && becomeAMemberSummary.color && becomeAMemberSummary.engine && becomeAMemberSummary.financing) {
      let dataLayer = window.dataLayer || [];
      let color = becomeAMemberSummary.color?.preSelectValue?.value;
      let engine = becomeAMemberSummary.engine?.preSelectValue?.value;
      let financing = becomeAMemberSummary.financing?.preSelectValue?.value;

      dataLayer.push({
        event: "payDepositForm",
        eventCategory: "membership pay deposit",
        eventAction: "form submitted",
        eventLabel: `${color} | ${engine} | ${financing}`
      });
    }
  };*/
  const billingInfoProps = {
    fields: billingInfo.fields,
    ref: billingInfoRef,
    addressList,
    addAddress,
    updateAddress,
    removeAddress,
    loadAddressList,
    noAddress
  };
  const summaryProps = {
    ...summary,
    match: match,
    callback: ({ color, engine }) => {
      let becomeAMemberSummary = {
        engine: {
          preSelectValue: engine
        },
        color: {
          preSelectValue: color
        }
      };
      onSummaryCallback && onSummaryCallback(becomeAMemberSummary);
    }
  };
  return (
    <section className="pre-sales-checkout grid">
      <HeroGradient {...hero} />
      {summary && (
        <div className="summary-container-mobile">
          <AccordionWrapper
            heading={{
              ...summaryProps.text.heading,
              typographyClass: "tpye-link"
            }}
          >
            <Summary
              {...{
                ...summaryProps,
                text: { ...summaryProps.text, heading: null },
                match: match
              }}
            />
          </AccordionWrapper>
        </div>
      )}
      <PreSalesBillingInfo {...billingInfoProps} />
      <PreSalesCardInfoInStore
        {...{
          ...cardInfo.fields,
          user,
          lang,
          inStore: true,
          qrCodeSrc,
          onSubmit: () => submitOrder()
        }}
      />
      {summary && (
        <div className="summary-container">
          <Summary {...summaryProps} />
        </div>
      )}
    </section>
  );
};
export default PreSalesCheckoutViewInStore;
